import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	pageDescription: {
		id: 'portfolio-3-dependency-settings.ui.subheader.page-description',
		defaultMessage:
			'Select the {configureIssueLinkTypesLink} that will be treated as dependencies in plans.',
		description: 'The subtitle on the dependency settings page.',
	},
});
